/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the hook used to retrieve the Theme Manager Context.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Hook to gain access to a react context.
 */
import { useEffect } from 'react';

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/**
 * Theme manager context which will be returned by the hook.
 */
import useMessageManagerContext from 'src/hooks/useMessageManagerContext';

/**
 * enumeration
 */
import { WindowView } from 'src/utils/MessageManager';

/**
 * Typings
 */
import * as Dtos from '../api/dtos';


/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

const useAppState = (
    view: WindowView,
    version: Dtos.Version | null,
    category: Dtos.Category | null,
    term: Dtos.Term | null,
    subterm: Dtos.Term | null,
    grade: Dtos.Grade | null
) => {
    const messageManager = useMessageManagerContext();

    useEffect(() => {
        if (version) {
            messageManager.updateAppState({
                view,
                selection: {
                    version,
                    category,
                    term,
                    subterm,
                    grade,
                    specification: null
                }
            });
        }
    }, [view, version, category, term, subterm, grade])
}

/*
 * ---------------------------------------------------------------------------------
 * Exports - Default
 * ---------------------------------------------------------------------------------
 */

export default useAppState;


// WEBPACK FOOTER //
// ./src/hooks/useAppState.ts